import { computed, toRefs } from "vue";
import uniqueId from "lodash.uniqueid";

export const useId = (
  props: { id: string; forceId: boolean },
  prefix: string
) => {
  const { id, forceId } = toRefs(props);

  return computed(() => {
    if (id.value.length === 0) {
      console.warn("Wrong input ID value");
    }

    if (forceId.value) {
      return id.value;
    }

    return `${prefix}-${id.value || uniqueId()}`;
  });
};
